export default __webpack_public_path__ + "static/media/serviceElement.8136c706.webp";